
import { Component, Prop, Vue } from 'nuxt-property-decorator';
import type { PropType } from 'vue';
import { Sale } from './types';
import StatisticsLicenseDetails from './StatisticsLicenseDetails.vue';
import Accordion from '@/components/ui/accordion/Accordion.vue';

@Component({
  components: { StatisticsLicenseDetails, Accordion }
})
export default class StatisticsLicenseSale extends Vue {
  @Prop({ type: Object as PropType<Sale>, default: () => {} })
  sale!: Sale;

  @Prop({ type: String, default: 'Bog' })
  unitCode!: string;

  licenseValue: string = '';
  accordionExpanded: boolean = false;

  renderContent() {
    this.accordionExpanded = !this.accordionExpanded;
  }

  getLicenseValue(val: string) {
    this.licenseValue = val;
  }
}
